import i18n from './attribute-category.properties';

/** @see net.disy.cadenza.repository.api.objecttype.AttributeCategory */
const AttributeCategoryInternal = {
  MEASURE: 'MEASURE',
  DIMENSION: 'DIMENSION',
  HIERARCHY: 'HIERARCHY'
} as const;

/** @see net.disy.cadenza.repository.api.objecttype.AttributeCategory */
export const AttributeCategory = {
  ...AttributeCategoryInternal,
  values: [ ...Object.values(AttributeCategoryInternal) ],
  i18n
} as const;

/** @see net.disy.cadenza.repository.api.objecttype.AttributeCategory */
export type AttributeCategory = keyof typeof AttributeCategoryInternal;
